// Google Analytics 4 helper for Lu.ft Pilates Studio.
// The gtag base script + config('G-XPTYKL9HB7') are loaded in public/index.html.
// SPA page_view events are dispatched from <RouteTracker /> on every route change.

export const GA_MEASUREMENT_ID = "G-XPTYKL9HB7";

const hasGtag = () =>
  typeof window !== "undefined" && typeof window.gtag === "function";

/**
 * Fire a GA4 page_view event for the current SPA location.
 * Called automatically by <RouteTracker /> for every route — current and future.
 */
export function trackPageView(path, title) {
  if (!hasGtag()) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: title || document.title,
    send_to: GA_MEASUREMENT_ID,
  });
}

/**
 * Generic GA4 custom event tracker.
 * Example: trackEvent("app_store_click", { surface: "desktop" })
 */
export function trackEvent(name, params = {}) {
  if (!hasGtag()) return;
  window.gtag("event", name, {
    send_to: GA_MEASUREMENT_ID,
    ...params,
  });
}
